// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddNewBotForm_formContainer__0TrEZ {
  display: flex;
  justify-content: center;
  align-self: center;
  height: max-content;
  background-color: #FFFFFF;
  padding: 24px;
  border-radius: 12px;
  position: relative;
}
@media (max-width: 1024px) {
  .AddNewBotForm_formContainer__0TrEZ {
    padding: 16px;
  }
}

.AddNewBotForm_title__76v0s {
  font-size: 18px;
  font-weight: 600;
}

.AddNewBotForm_subTitle__rY8ca {
  font-size: 16px;
  color: #555F6D;
  margin-top: 4px;
  margin-bottom: 32px;
}

.AddNewBotForm_close__1Edmd {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 24px;
  right: 24px;
  background-color: transparent;
  border: 1px solid #CFD6DD;
  border-radius: 8px;
}

.AddNewBotForm_createButtonContainer__vRVke {
  margin-top: 16px;
  margin-bottom: 8px;
}

.AddNewBotForm_textField__jKsb6 {
  margin-top: 8px;
  width: 304px;
  border-radius: 8px;
  border: 1px solid #555F6D;
  height: 40px;
  padding: 0 7px;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .AddNewBotForm_textField__jKsb6 {
    width: 280px;
  }
}

.AddNewBotForm_nonotificationStyle__W2wSZ {
  position: fixed;
  left: 20px;
  bottom: 20px;
  background-color: green;
  color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/AddNewBotForm/AddNewBotForm.module.scss","webpack://./src/styles/colors.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBCRI;EDSJ,aAAA;EACA,mBAAA;EAKA,kBAAA;AANJ;AEPQ;EFCR;IAUQ,aAAA;EAAN;AACF;;AAKA;EACI,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,cCrBQ;EDsBR,eAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAFJ;AElDQ;EF6CR;IAUQ,YAAA;EADN;AACF;;AAIA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AADA","sourcesContent":["@use '../../styles/colors' as colors; \n@use '../../styles/responsive' as rwd; \n\n.formContainer {\n    display: flex;\n    justify-content: center;\n    align-self: center;\n    height: max-content;\n    background-color: colors.$white;\n    padding: 24px;\n    border-radius: 12px;\n\n    @include rwd.breakpoint(small) {\n        padding: 16px;\n    }\n    position: relative;\n}\n\n\n.title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.subTitle {\n    font-size: 16px;\n    color: colors.$secondary;\n    margin-top: 4px;\n    margin-bottom: 32px;\n}\n\n.close {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 24px;\n    right: 24px;\n    background-color: transparent;\n    border: 1px solid colors.$action;\n    border-radius: 8px;\n}\n\n.createButtonContainer {\n    margin-top: 16px;\n    margin-bottom: 8px;\n}\n\n.textField {\n    margin-top: 8px;\n    width: 304px;\n    border-radius: 8px;\n    border: 1px solid colors.$secondary;\n    height: 40px;\n    padding: 0 7px;\n    box-sizing: border-box;\n\n    @include rwd.breakpoint(small) {\n        width: 280px;\n    }\n}\n\n.nonotificationStyle {\nposition: fixed;\nleft: 20px;\nbottom: 20px;\nbackground-color: green;\ncolor: white;\npadding: 10px;\nborder-radius: 5px;\nbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\ndisplay: block;\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `AddNewBotForm_formContainer__0TrEZ`,
	"title": `AddNewBotForm_title__76v0s`,
	"subTitle": `AddNewBotForm_subTitle__rY8ca`,
	"close": `AddNewBotForm_close__1Edmd`,
	"createButtonContainer": `AddNewBotForm_createButtonContainer__vRVke`,
	"textField": `AddNewBotForm_textField__jKsb6`,
	"nonotificationStyle": `AddNewBotForm_nonotificationStyle__W2wSZ`
};
export default ___CSS_LOADER_EXPORT___;
